// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1pqpd","info":"PatientInfo_info__ZJd5G"};